import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { updatePassword } from 'firebase/auth';
import { auth, db } from '../firebaseConfig';
import { doc, updateDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { IoLockClosedOutline, IoEye, IoEyeOff, IoCheckmarkCircleOutline } from 'react-icons/io5';
import kondifyLogo from '../assets/Kondify letra negra sin fondo.png';

function ActualizarContrasenaScreen() {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres.');
      return;
    }

    if (password !== confirmPassword) {
      setError('Las contraseñas no coinciden.');
      return;
    }

    setLoading(true);

    try {
      // 1. Update password in Firebase Auth
      await updatePassword(auth.currentUser, password);

      // 2. Update status in Firestore
      const userRef = doc(db, 'usuarios', currentUser.uid);
      await updateDoc(userRef, { cambiarContrasena: false });

      setSuccess(true);
      setTimeout(() => {
        navigate('/app', { replace: true });
        window.location.reload(); // Refresh to reload AuthContext state
      }, 2000);
    } catch (err) {
      console.error("Error updating password:", err);
      setError('Error al actualizar contraseña: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Inter', sans-serif" }}>
      <div className="login-card" style={{ width: '90%', maxWidth: '420px', padding: '40px 30px', background: 'white', borderRadius: '32px', boxShadow: '0 20px 40px rgba(0,0,0,0.06)' }}>
        
        <div style={{ textAlign: 'center', marginBottom: '35px' }}>
          <img src={kondifyLogo} alt="Kondify" style={{ height: '48px', marginBottom: '24px' }} />
          <h2 style={{ fontSize: '1.5rem', fontWeight: '800', color: '#1e293b', margin: '0 0 10px 0' }}>
            Actualizar Contraseña
          </h2>
          <p style={{ fontSize: '0.9rem', color: '#64748b', margin: 0, lineHeight: '1.5' }}>
            Como medida de seguridad, debes actualizar tu contraseña temporal antes de ingresar a la aplicación.
          </p>
        </div>

        {error && (
          <div style={{ background: '#fee2e2', color: '#991b1b', padding: '12px 16px', borderRadius: '14px', fontSize: '0.85rem', marginBottom: '20px', fontWeight: '500' }}>
            {error}
          </div>
        )}

        {success ? (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <IoCheckmarkCircleOutline size={56} style={{ color: '#22c55e', marginBottom: '15px' }} />
            <h3 style={{ fontSize: '1.15rem', color: '#1e293b', margin: '0 0 8px 0', fontWeight: '700' }}>¡Contraseña Actualizada!</h3>
            <p style={{ fontSize: '0.85rem', color: '#64748b', margin: 0 }}>Redirigiéndote a tu pantalla de inicio...</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            
            <div style={{ position: 'relative' }}>
              <label style={{ display: 'block', fontSize: '0.82rem', color: '#475569', fontWeight: '700', marginBottom: '8px' }}>
                Nueva Contraseña
              </label>
              <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #e2e8f0', borderRadius: '14px', padding: '0 16px', backgroundColor: '#f8fafc' }}>
                <IoLockClosedOutline size={18} style={{ color: '#94a3b8', marginRight: '10px' }} />
                <input 
                  type={showPassword ? "text" : "password"} 
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="Mínimo 6 caracteres"
                  style={{ width: '100%', border: 'none', outline: 'none', padding: '14px 0', fontSize: '0.92rem', background: 'transparent', color: '#334155' }}
                  required
                />
                <button 
                  type="button" 
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: '#94a3b8' }}
                >
                  {showPassword ? <IoEyeOff size={18} /> : <IoEye size={18} />}
                </button>
              </div>
            </div>

            <div>
              <label style={{ display: 'block', fontSize: '0.82rem', color: '#475569', fontWeight: '700', marginBottom: '8px' }}>
                Confirmar Contraseña
              </label>
              <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #e2e8f0', borderRadius: '14px', padding: '0 16px', backgroundColor: '#f8fafc' }}>
                <IoLockClosedOutline size={18} style={{ color: '#94a3b8', marginRight: '10px' }} />
                <input 
                  type={showPassword ? "text" : "password"} 
                  value={confirmPassword}
                  onChange={e => setConfirmPassword(e.target.value)}
                  placeholder="Repite la contraseña"
                  style={{ width: '100%', border: 'none', outline: 'none', padding: '14px 0', fontSize: '0.92rem', background: 'transparent', color: '#334155' }}
                  required
                />
              </div>
            </div>

            <button 
              type="submit" 
              disabled={loading}
              style={{ 
                width: '100%', 
                padding: '14px', 
                background: 'linear-gradient(135deg, #7B61FF 0%, #6348D1 100%)', 
                color: 'white', 
                border: 'none', 
                borderRadius: '14px', 
                fontWeight: 'bold', 
                fontSize: '0.95rem',
                cursor: 'pointer', 
                marginTop: '10px',
                boxShadow: '0 8px 20px rgba(99, 72, 209, 0.2)',
                transition: 'all 0.2s'
              }}
            >
              {loading ? 'Guardando...' : 'Guardar y Continuar'}
            </button>

            <button 
              type="button" 
              onClick={logout}
              style={{ background: 'none', border: 'none', color: '#64748b', fontSize: '0.85rem', textDecoration: 'underline', cursor: 'pointer', alignSelf: 'center' }}
            >
              Cerrar Sesión
            </button>

          </form>
        )}

      </div>
    </div>
  );
}

export default ActualizarContrasenaScreen;
